import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loads-v2",
  "use": "icon-loads-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-loads-v2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.5 2a2 2 0 0 0-2 2v2H3a1 1 0 0 0-1 1v4a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V7a1 1 0 0 0-1-1h-3.5V4a2 2 0 0 0-2-2h-6Zm6 4V4h-6v2h6ZM14 15.268H9V17a1 1 0 1 1-2 0v-1.732H5a2.99 2.99 0 0 1-2-.764V20a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-5.496a2.989 2.989 0 0 1-2 .764h-2V17a1 1 0 1 1-2 0v-1.732Z\" fill=\"#A4B4D0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol